export default "__VITE_ASSET__51a4842c__"